import { Component, OnDestroy, OnInit } from '@angular/core';
import { BannerHotelDealModel } from 'app/model/banner/banner';
import { BannerDisplayModel } from 'app/model/banner/banner-display';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { BannerService } from 'app/services/banner/banner.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import $ from 'jquery';
import 'owl.carousel/dist/owl.carousel.js';
import { Subscription } from 'rxjs/Subscription';
import { UserService } from 'app/services/user/user.service';

@Component({
  selector: 'act-banner-promotion',
  templateUrl: './banner-promotion.component.html',
  styleUrls: ['./banner-promotion.component.scss']
})
export class BannerPromotionComponent implements OnInit, OnDestroy {
  public bannerType = 'hotel_deals';

  public banners: BannerDisplayModel[];
  private lang;

  private subscriptionLanguage: Subscription;
  private subscriptionGetBannerList: Subscription;

  constructor(
    private appConfigService: AppConfigService,
    private bannerService: BannerService,
    private utilitiesService: UtilitiesService,
    private userService: UserService,
  ) { }

  get isMobile() {
    return this.utilitiesService.isMobile();
  }

  ngOnInit() {
    this.subscriptionLanguage && this.subscriptionLanguage.unsubscribe();
    this.subscriptionLanguage = this.appConfigService.getLanguageObs()
      .subscribe((val) => {
        if (this.lang !== val) {
          this.fetchData();
        }
      });

    this.fetchData();
  }

  initCarousel() {
    setTimeout(() => {
      if (this.utilitiesService.isMobile()) {
        $('.banner-owl').owlCarousel({
          loop: true,
          margin: 10,
          nav: false,
          items: 1
        });
      }
    });
  }

  fetchData() {
    this.banners = undefined;
    const { companyId } = this.userService.getUser();
    this.subscriptionGetBannerList && this.subscriptionGetBannerList.unsubscribe();
    this.subscriptionGetBannerList = this.bannerService.getBannerHotelDealList(companyId, this.appConfigService.getLanguage(), this.utilitiesService.isMobile())
      .subscribe((res) => {
        this.banners = this.bannerService.transformToDisplayBanner(res);
        this.initCarousel();
      }, (res) => {
        this.banners = undefined;
      });
  }

  openNewTab(banner: BannerHotelDealModel, isMobileOnly: boolean) {
    if (isMobileOnly) {
      if (this.utilitiesService.isMobile()) {
        window.open(banner.link);
      }
    } else {
      window.open(banner.link);
    }
  }

  ngOnDestroy() {
    this.subscriptionLanguage && this.subscriptionLanguage.unsubscribe();
    this.subscriptionGetBannerList && this.subscriptionGetBannerList.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/banner-promotion/banner-promotion.component.ts